import {Dispatch, FC, SetStateAction, useEffect} from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../../../_metronic/helpers'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import {InputNumberDecimal} from '../../../../../../components/UI/Input'
import {UpdateCostDto} from '../../../../model/parameter.model'
import {updateCostsService} from '../../../../services/parameter.service'
import {ShowSnackBar} from '../../../../../../util/functions'
interface Props {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
  itemToEdit: any
  getCosts: () => void
}

const ModalUpdateCosts: FC<Props> = ({show, setShow, itemToEdit, getCosts}) => {
  const handleClose = () => {
    setShow(false)
  }

  const updateCostSchema = Yup.object().shape({
    ParamFacturacionCabId: Yup.string().required('Param Facturacion es requerido'),
    RangoCodigo: Yup.string().required('Rango es requerido'),
    Costo: Yup.number().required('Costo es requerido'),
  })

  const {
    register,
    setValue,
    handleSubmit,
    formState: {errors},
  } = useForm<UpdateCostDto>({
    resolver: yupResolver(updateCostSchema),
  })

  const onSubmit = async (data: UpdateCostDto) => {
    try {
      const {data: res} = await updateCostsService(data)
      if (!res.error) {
        ShowSnackBar('Se actualizó con éxito')
        handleClose()
        getCosts()
      } else {
        ShowSnackBar(res.message, 'error')
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    setValue('ParamFacturacionCabId', itemToEdit.ParamFacturacionCabId)
    setValue('TipoHabitacionId', itemToEdit.TipoHabitacionId)
    setValue('RangoCodigo', itemToEdit.RangoCodigo)
    setValue('Costo', itemToEdit.Costo)
    setValue('TipoRopaId', itemToEdit.TipoRopaId)
  }, [])

  return (
    <Modal
      className='modal fade'
      show={show}
      dialogClassName='modal-md'
      aria-hidden='true'
      onHide={handleClose}
    >
      <div className='modal-content'>
        <div className='modal-header'>
          <h5 className='modal-title'>Editar Costo</h5>
          <div className='btn btn-icon btn-sm btn-active-light-primary ms-2' onClick={handleClose}>
            <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-2x' />
          </div>
        </div>
        <div className='modal-body'>
          <form>
            <div className='p-6'>
              <div className='d-flex'>
                <div className='col-6'>
                  <div className=''>
                    <label>Costo:</label>
                    <InputNumberDecimal
                      name='Costo'
                      textPlaceholder='Escribe el costo'
                      register={register}
                      errors={errors}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='d-flex justify-content-center mb-3'>
              <button type='button' className='btn btn-light-primary me-5' onClick={handleClose}>
                Cancelar
              </button>
              <button type='button' className='btn btn-primary' onClick={handleSubmit(onSubmit)}>
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}

export {ModalUpdateCosts}
